import React, { Component } from 'react';
import { connect } from 'react-redux';
import AllnewsContainer from "../news/containers/allnewscontainer.component";
import { getFestivalDetails, getFestivalLocations, getEvents } from '../../../SHARED/actions/festival.actions';
import { storeSelectedEventLocation } from "../../../SHARED/actions/filters.actions";
import SliderFestivalContainer from "./containers/sliderfestivalcontainer.component";
import Moment from "react-moment";
import Parser from 'html-react-parser';
import SearchByTag from "../../../SHARED/components/searchbytag/searchbytag.component";
import WeekDaysCardsFestival from "../../../SHARED/components/weekdayscardfestival/weekdayscardfestival.component";
import FestivalResults from "../../../SHARED/components/festivalresults/festivalresults.component";
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import { Helmet } from 'react-helmet';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
import { getFormattedTextForMeta } from '../../../SHARED/helpers/general.helper';
class FestivalDetails extends Component {

    componentWillMount(){
        window.scrollTo(0, 0);
        const idUrl = this.props.match.params.id;
        this.props.getFestivalDetails(idUrl);
        this.props.getFestivalLocations(idUrl);
    }

    componentDidMount() {
        pageViewEvent(this.props.festivalDetails.festival_title, window.location.href)
     }

    handleChange = (event) => {
        const payload = {
            festival_id: this.props.festivalDetails.festival_id,
            date: this.props.selectedFestivalDate,
            location: event.target.value
        }
        this.props.getEvents(payload);
        this.props.storeSelectedEventLocation(event.target.value);
    }

    getFilters = () => {
        if(this.props.festivalLocations){
            return <select onChange={this.handleChange}>
                <option value="">Ora</option>
                <option disabled={true}>Locatie</option>
                {
                    this.props.festivalLocations.map((item, i) => {
                        return <option key={i} value={item.event_location_name}>{item.event_location_name}</option>
                    })
                }
            </select>
        }
    }

    render() {
        return (
            <div className="container-fluid festival-details">
                {this.props.loading !== 0 ? <Spinner /> : ''} 
                <Helmet>
                    <title>{getFormattedTextForMeta(this.props.festivalDetails.festival_title, 0)}</title>
                    <meta name="description" content={this.props.festivalDetails.festival_description && getFormattedTextForMeta(this.props.festivalDetails.festival_description, 1)}/>
                    <link rel='canonical' href={window.location.href}/>
                </Helmet>
                <div className="row">
                    <div className="col-lg-9 p-3">
                        <SliderFestivalContainer slides={this.props.festivalDetails.evenimente_promovate} />
                        <div className="col-lg-12 clearfix nopadding festival-tag">
                            <span className="filter-button">Festival</span>
                        </div>
                        <div className="col-lg-12 clearfix nopadding">
                            <h3 className="text-white">{this.props.festivalDetails.festival_title}</h3>
                        </div>
                        <div className="col-lg-12 clearfix nopadding">
                            <span className="white-text festival-period">
                                <Moment format="DD MMMM YYYY" locale="ro" unix>
                                    { this.props.festivalDetails.festival_period_start }
                                </Moment>
                                <span> - </span>
                                <Moment format="DD MMMM YYYY" locale="ro" unix>
                                    { this.props.festivalDetails.festival_period_end }
                                </Moment>
                                {", " + this.props.festivalDetails.festival_location}
                            </span>

                            <div className="festival-details-description">
                                { this.props.festivalDetails.festival_description && Parser(this.props.festivalDetails.festival_description) }
                            </div>
                            <div className="row">
                                <div className="col-lg-12 festival-program-days">
                                    <h3>PROGRAM { this.props.festivalDetails.festival_title }</h3>
                                    <div className="col-lg-12">
                                        <div className="row">
                                            <WeekDaysCardsFestival 
                                                festival_start = {this.props.festivalDetails.festival_period_start}
                                                festival_end = {this.props.festivalDetails.festival_period_end}
                                                festival_id = {this.props.festivalDetails.festival_id}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 order-after">
                                <span>Ordonează după:</span>
                                {this.getFilters()}
                            </div>
                            <FestivalResults events={this.props.events.reverse()}/>
                        </div>
                    </div>
                    <div className="col-lg-3 w-10 p-3">
                        <AllnewsContainer />
                        <SearchByTag/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    festivalDetails: state.festival.festivalDetails,
    festivalLocations: state.festival.festivalLocations,
    events: state.festival.events,
    selectedFestivalDate: state.filters.festival_details_filters.selected_festival_date,
    loading: state.loading.pendingRequests,
});

export default connect(mapStateToProps,{getFestivalDetails, getFestivalLocations, getEvents, storeSelectedEventLocation})(FestivalDetails);



// WEBPACK FOOTER //
// ./src/FO/components/festivaldetails/festivaldetails.component.js